import Link from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';
import { ReactNode } from 'react';

export const CustomLink = (
  { href, children, ...props }: { href: string, children: ReactNode },
) => (
  <Link
    component={RouterLink}
    to={href}
    target="_blank"
    {...props}
  >
    {children}
  </Link>
);
